import { simpleSet } from '@r/reducers/utils';

const setCalculationModeProjectPercentageLossOptions = simpleSet as
  redux.reducers.calculationMode.settings.information.percentageLoss.options;

export const options = setCalculationModeProjectPercentageLossOptions(
  'SET_CALCULATION_MODE_PROJECT_PERCENTAGE_LOSS_OPTIONS',
  []
);
